
import EpisodeCard from "@/components/EpisodeCard";
import EpisodesLoadingState from "./EpisodesLoadingState";
import EpisodesEmptyState from "./EpisodesEmptyState";
import EpisodesStats from "./EpisodesStats";
import EpisodesPagination from "./EpisodesPagination";
import { Episode, Category } from "./types";

interface EpisodesGridProps {
  isLoading: boolean;
  filteredEpisodes: Episode[];
  paginatedEpisodes: Episode[];
  searchTerm: string;
  selectedCategory: string | null;
  categories: Category[];
  setSearchTerm: (term: string) => void;
  setSelectedCategory: (categoryId: string | null) => void;
  setSelectedVideo: (youtubeId?: string, vimeoId?: string, videoPlatform?: "youtube" | "vimeo") => void;
  currentPage: number;
  totalPages: number;
  goToPage: (page: number) => void;
  goToNextPage: () => void;
  goToPreviousPage: () => void;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

const EpisodesGrid = ({
  isLoading,
  filteredEpisodes,
  paginatedEpisodes,
  searchTerm,
  selectedCategory,
  categories,
  setSearchTerm,
  setSelectedCategory,
  setSelectedVideo,
  currentPage,
  totalPages,
  goToPage,
  goToNextPage,
  goToPreviousPage,
  hasNextPage,
  hasPreviousPage,
}: EpisodesGridProps) => {
  return (
    <section className="w-full py-20 bg-gradient-to-br from-sky-blue/20 via-white to-bobo-green/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {isLoading ? (
          <EpisodesLoadingState />
        ) : filteredEpisodes.length === 0 ? (
          <EpisodesEmptyState
            searchTerm={searchTerm}
            selectedCategory={selectedCategory}
            setSearchTerm={setSearchTerm}
            setSelectedCategory={setSelectedCategory}
          />
        ) : (
          <>
            <EpisodesStats
              paginatedEpisodes={paginatedEpisodes}
              filteredEpisodes={filteredEpisodes}
              selectedCategory={selectedCategory}
              categories={categories}
              currentPage={currentPage}
              totalPages={totalPages}
            />
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mb-12">
              {paginatedEpisodes.map((episode) => (
                <EpisodeCard
                  key={episode.id}
                  title={episode.title}
                  description={episode.description || ""}
                  thumbnail={episode.thumbnail_url || ""}
                  duration={episode.duration || ""}
                  youtubeId={episode.youtube_id || undefined}
                  vimeoId={episode.vimeo_id || undefined}
                  videoPlatform={episode.video_platform || undefined}
                  onPlay={setSelectedVideo}
                />
              ))}
            </div>

            <EpisodesPagination
              currentPage={currentPage}
              totalPages={totalPages}
              goToPage={goToPage}
              goToNextPage={goToNextPage}
              goToPreviousPage={goToPreviousPage}
              hasNextPage={hasNextPage}
              hasPreviousPage={hasPreviousPage}
            />
          </>
        )}
      </div>
    </section>
  );
};

export default EpisodesGrid;
